const makeContactsFormat = (contacts) => {
	const result = contacts.map((contact) => {
		if (contact.phoneWorkExt === '' && contact.phoneCellExt === '') {
			return {
				id: contact.id,
				firstName: contact.firstName,
				lastName: contact.lastName,
				phoneWork: contact.phoneWorkDial + ' ' + contact.phoneWork,
				phoneMobile: contact.phoneCellDial + ' ' + contact.phoneCell,
				emailWork: contact.emailWork,
			};
		} else {
			return {
				id: contact.id,
				firstName: contact.firstName,
				lastName: contact.lastName,
				phoneWork: contact.phoneWorkDial + ' ' + contact.phoneWork + ', ' + contact.phoneWorkExt,
				phoneMobile: contact.phoneCellDial + ' ' + contact.phoneCell + ', ' + contact.phoneCellExt,
				emailWork: contact.emailWork,
			};
		}
	});
	return result;
};

export default makeContactsFormat;
